import type {MembershipExpandedCommon} from '../../../../api/membership';

import {membershipStore} from '../../../../api/membership';

export abstract class AcceptRequestedMembershipsStrategy {
  async decline(memberships: MembershipExpandedCommon[]) {
    await membershipStore.declineBatch(
      memberships.map(membership => ({membership})),
    );
  }

  abstract execute(): Promise<void>;
}
